import type { ChatDocumentDTO } from '@shared/schemas/chat';
import type { DocumentGenerationResultDTO } from '@shared/schemas/document-generation';

export const CODEGEN_DOCUMENT_ID_PREFIX = 'docgen:';

export function isCodegenChatDocument(document: ChatDocumentDTO) {
  return document.documentId.startsWith(CODEGEN_DOCUMENT_ID_PREFIX);
}

export function buildCodegenChatDocument(input: {
  result: DocumentGenerationResultDTO;
  title: string;
}): ChatDocumentDTO {
  return {
    content: '',
    documentId: `${CODEGEN_DOCUMENT_ID_PREFIX}${input.result.generationId}`,
    filename: input.result.filename,
    kind: 'attachment',
    mediaType: input.result.contentType,
    sourceUrl: input.result.downloadUrl,
    status: 'ready',
    summary: null,
    title: input.title,
  };
}
